<template>
<div class="EventsCalendar">

  <div class="menuDats">

    <div class="onceDay" @click="change1" v-on:click="allEventsGet" :class="{ 'active': thisweek[0].status }">
      <div class="numberDate">
        {{thisweek[0].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[0].daytitle}}
      </div>
    </div>

    <div class="onceDay" @click="change2" v-on:click="allEventsGet" :class="{ 'active': thisweek[1].status }">
      <div class="numberDate">
        {{thisweek[1].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[1].daytitle}}
      </div>
    </div>

    <div class="onceDay" @click="change3" v-on:click="allEventsGet" :class="{ 'active': thisweek[2].status }">
      <div class="numberDate">
        {{thisweek[2].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[2].daytitle}}
      </div>
    </div>

    <div class="onceDay" @click="change4" v-on:click="allEventsGet" :class="{ 'active': thisweek[3].status }">
      <div class="numberDate">
        {{thisweek[3].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[3].daytitle}}
      </div>
    </div>

    <div class="onceDay" @click="change5" v-on:click="allEventsGet" :class="{ 'active': thisweek[4].status }">
      <div class="numberDate">
        {{thisweek[4].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[4].daytitle}}
      </div>
    </div>

    <div class="onceDay" @click="change6" v-on:click="allEventsGet" :class="{ 'active': thisweek[5].status }">
      <div class="numberDate">
        {{thisweek[5].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[5].daytitle}}
      </div>
    </div>

    <div class="onceDay" @click="change7" v-on:click="allEventsGet" :class="{ 'active': thisweek[6].status }">
      <div class="numberDate">
        {{thisweek[6].daynumber}}
      </div>
      <div class="titleDate">
        {{thisweek[6].daytitle}}
      </div>
    </div>
  </div>


  <ul class="wrapCards">
    <li v-for="item of allEvents" :key="item.eventid" id="activeEvent">

      <div class="wrapEvent out" v-if="moment.utc(item.EndTime).local().format('YYYY-MM-DD HH:mm') <  moment().local().format('YYYY-MM-DD HH:mm')">
        <img width="130px" height="130px" :src="'http://www.lovecity3d.com/Events/image.ashx?mediaId='+ item.ThumbID">
        <div class="eventInfo">
          <div>
            <div class="title">
              <h2>{{item.title}}</h2>
            </div>
            <p style="font-weight:600; font-size:14px; display:flex; flex-flow:column;margin-top: 2px;">
              <span>
                <i class="el-icon-time" style="font-weight:600; font-size:14px;"></i> {{moment.utc(item.StartTime).local().format('HH:mm')}} - {{moment.utc(item.EndTime).local().format('HH:mm')}}
              </span>
              <span class="userInfo">
                <i class="el-icon-user-solid" style="font-weight:600; font-size:14px;"></i> <a target="_blank" :href="'http://www.lovecity3d.com/Net/profile/view_profile.aspx?MemberId='+item.OwnerID">{{item.username}}</a>
              </span>
            </p>
          </div>
          <div class="bottom">
            <a :href="'http://www.lovecity3d.com/Events/Event/?EventID='+item.eventid" target="_blank" class="info">Подробнее</a>
            <a :href="'vww://lovecity3d.vww/@' + item.InstanceID + '#enter'" class="enter">Перейти</a>
          </div>
        </div>
      </div>


  <div class="wrapEvent activeEvent findElement" v-else-if="moment.utc(item.StartTime).local().format('YYYY-MM-DD HH:mm') <  moment().local().format('YYYY-MM-DD HH:mm') && moment.utc(item.EndTime).local().format('YYYY-MM-DD HH:mm') >  moment().local().format('YYYY-MM-DD HH:mm')">
    <img width="130px" height="130px" :src="'http://www.lovecity3d.com/Events/image.ashx?mediaId='+ item.ThumbID">
    <div class="eventInfo">
      <div>
        <div class="title">
          <h2>{{item.title}}</h2>
        </div>
        <p style="font-weight:600; font-size:14px; display:flex; flex-flow:column;margin-top: 2px;">
          <span>
            <i class="el-icon-caret-right" style="font-weight:600; font-size:14px;"></i>В процессе
          </span>
          <span class="userInfo">
            <i class="el-icon-user-solid" style="font-weight:600; font-size:14px;"></i> <a target="_blank" :href="'http://www.lovecity3d.com/Net/profile/view_profile.aspx?MemberId='+item.OwnerID">{{item.username}}</a>
          </span>
        </p>
      </div>
      <div class="bottom">
        <a :href="'http://www.lovecity3d.com/Events/Event/?EventID='+item.eventid" target="_blank" class="info">Подробнее</a>
        <a :href="'vww://lovecity3d.vww/@' + item.InstanceID + '#enter'" class="enter">Перейти</a>
      </div>
    </div>
  </div>


  <div class="wrapEvent findElement" v-else-if="moment.utc(item.StartTime).local().format('YYYY-MM-DD HH:mm') >  moment().local().format('YYYY-MM-DD HH:mm') && moment.utc(item.EndTime).local().format('YYYY-MM-DD HH:mm') >  moment().local().format('YYYY-MM-DD HH:mm')">
    <img width="130px" height="130px" :src="'http://www.lovecity3d.com/Events/image.ashx?mediaId='+ item.ThumbID">
    <div class="eventInfo">
      <div>
        <div class="title">
          <h2>{{item.title}}</h2>
        </div>
        <p style="font-weight:600; font-size:14px; display:flex; flex-flow:column;margin-top: 2px;">
          <span>
            <i class="el-icon-time" style="font-weight:600; font-size:14px;"></i> {{moment.utc(item.StartTime).local().format('HH:mm')}} - {{moment.utc(item.EndTime).local().format('HH:mm')}}
          </span>
          <span class="userInfo">
            <i class="el-icon-user-solid" style="font-weight:600; font-size:14px;"></i> <a target="_blank" :href="'http://www.lovecity3d.com/Net/profile/view_profile.aspx?MemberId='+item.OwnerID">{{item.username}}</a>
          </span>
        </p>
      </div>
      <div class="bottom">
        <a :href="'http://www.lovecity3d.com/Events/Event/?EventID='+item.eventid" target="_blank" class="info">Подробнее</a>
        <a :href="'vww://lovecity3d.vww/@' + item.InstanceID + '#enter'" class="enter">Перейти</a>
      </div>
    </div>


</div>



</li>
  </ul>

</div>
</template>

<script>
export default {
  name: 'EventsCalendar',
  data() {
    return {
      endpoint: '',
      allEvents: [],
      dateNow: Date.now(),
      thisweek: [{
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
        {
          daytitle: '',
          daynumber: '',
          fulldate: '',
          status: false
        },
      ]
    };
  },
  methods: {

    change1(){
      this.value = (this.thisweek[0].fulldate.getFullYear()) + '-' + (this.thisweek[0].fulldate.getMonth()+1) + '-' + (this.thisweek[0].fulldate.getDate());
      this.value2 = (this.thisweek[1].fulldate.getFullYear()) + '-' + (this.thisweek[1].fulldate.getMonth()+1) + '-' + (this.thisweek[1].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[0].status = true;
    },
    change2(){
      this.value = (this.thisweek[1].fulldate.getFullYear()) + '-' + (this.thisweek[1].fulldate.getMonth()+1) + '-' + (this.thisweek[1].fulldate.getDate());
      this.value2 = (this.thisweek[2].fulldate.getFullYear()) + '-' + (this.thisweek[2].fulldate.getMonth()+1) + '-' + (this.thisweek[2].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[1].status = true;
    },
    change3(){
      this.value = (this.thisweek[2].fulldate.getFullYear()) + '-' + (this.thisweek[2].fulldate.getMonth()+1) + '-' + (this.thisweek[2].fulldate.getDate());
      this.value2 = (this.thisweek[3].fulldate.getFullYear()) + '-' + (this.thisweek[3].fulldate.getMonth()+1) + '-' + (this.thisweek[3].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[2].status = true;
    },
    change4(){
      this.value = (this.thisweek[3].fulldate.getFullYear()) + '-' + (this.thisweek[3].fulldate.getMonth()+1) + '-' + (this.thisweek[3].fulldate.getDate());
      this.value2 = (this.thisweek[4].fulldate.getFullYear()) + '-' + (this.thisweek[4].fulldate.getMonth()+1) + '-' + (this.thisweek[4].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[3].status = true;
    },
    change5(){
      this.value = (this.thisweek[4].fulldate.getFullYear()) + '-' + (this.thisweek[4].fulldate.getMonth()+1) + '-' + (this.thisweek[4].fulldate.getDate());
      this.value2 = (this.thisweek[5].fulldate.getFullYear()) + '-' + (this.thisweek[5].fulldate.getMonth()+1) + '-' + (this.thisweek[5].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[4].status = true;
    },
    change6(){
      this.value = (this.thisweek[5].fulldate.getFullYear()) + '-' + (this.thisweek[5].fulldate.getMonth()+1) + '-' + (this.thisweek[5].fulldate.getDate());
      this.value2 = (this.thisweek[6].fulldate.getFullYear()) + '-' + (this.thisweek[6].fulldate.getMonth()+1) + '-' + (this.thisweek[6].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[5].status = true;
    },
    change7(){
      this.value = (this.thisweek[6].fulldate.getFullYear()) + '-' + (this.thisweek[6].fulldate.getMonth()+1) + '-' + (this.thisweek[6].fulldate.getDate());
      this.value2 = (this.thisweek[7].fulldate.getFullYear()) + '-' + (this.thisweek[7].fulldate.getMonth()+1) + '-' + (this.thisweek[7].fulldate.getDate());
      for(let i=0; i<7; i++){
        this.thisweek[i].status = false;
      }
      this.thisweek[6].status = true;
    },


    allEventsGet() {
      fetch('https://lovecity3d.com/Postback/WorldMap/EventsList.ashx?StartDate=' + this.value + '&EndDate=' + this.value2)
        .then(response => response.json())
        .then(data => {
          this.allEvents = data;
          this.$nextTick(() => {
            document.getElementsByClassName("findElement")[0].id = "findElement";

            const id = 'findElement';
            const yOffset = -95;
            const element = document.getElementById(id);
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({top: y, behavior: 'smooth'});
          });
        });
    },

    thisDate: function() {
      const moment = require('moment');
      let thisDate2 = moment().utc().local()
      let thisDate = new Date(thisDate2);
      let week = [];
      let days = [
        'Воскресенье',
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота'
      ];

      week[0] = new Date(thisDate.setDate(thisDate.getDate()))
      var n0 = week[0].getDay();
      this.thisweek[0].daytitle = days[n0]
      this.thisweek[0].daynumber = week[0].getDate()
      this.thisweek[0].fulldate = week[0]

      for(let i=1; i<8; i++){
        week[i] = new Date(thisDate.setDate(thisDate.getDate() + 1))
        this.thisweek[i].daynumber = week[i].getDate()
        this.thisweek[i].fulldate = week[i]

        var n = week[i].getDay();
        this.thisweek[i].daytitle = days[n]
      }
    }
  },

  created: function() {
    this.thisDate()
    this.change1()
    this.allEventsGet()

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



.menuDats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 800px;
  position: fixed;
  z-index: 1;
  top: -14px;
}

.EventsCalendar {
    width: 800px;
    margin: auto;
    ul {
      list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          width: 800px;
          box-sizing: border-box;
          justify-content: space-between;
          padding: 68px 13px 0px 13px;
        li {
            display: flex;
            width: 380px;
            box-sizing: border-box;
        }
    }
}

ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.menuDay {
    width: 100%;
    ul {
        list-style: none;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-around;
        padding: 0;
        margin: 0;
        li {
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 20px;
            a {
                color: white;
                font-weight: 900;
            }
        }
    }
}

.wrapEvent {
    width: 100%;
    height: 130px;
    background: white;
    border-radius: 10px;
    display: flex;
    img{
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      min-width: 130px;
      min-height: 130px;
    }
    .eventInfo {
        width: 100%;
        padding-left: 18spx;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        padding: 10px 10px 10px 13px;
        .title a {
            text-decoration: none;
            color: black;
            &:hover {
                text-decoration: underline;
            }
        }
        h2,
        p {
            margin: 0;
            padding: 0;
        }
        h2 {
          font-size: 16px;
          font-weight: 800;
          line-height: 17px;
          overflow: hidden;
          max-height: 35px;
        }
    }
}
.titleDate{
      font-size: 13px;
}
.buttons {
    display: flex;
    flex-flow: column;
}

.onceDay{
  cursor: pointer;
  background: #282828;
  color: white;
  width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    padding: 10px 0px;
    border-left: 1px solid #ffffff08;
    &:last-child{
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
    }
    &:first-child{
      border-bottom-left-radius: 10px;
      border-top-left-radius: 10px;
    }

}
.active{
  color: white;
  background: #9e238e;
  /* font-weight: 400; */
  padding: 15px 0px;
  border-radius: 6px;
}
.numberDate {
  font-size: 35px;
  padding-top: 2px;
  }
.wrapCards{
  margin-top: 25px!important;
}
  .wrapCards li{
    padding-bottom: 20px;
  }

.bottom{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-right: 10px;
  a.enter{
    background: #9e238e;
    padding: 8px 20px;
    border-radius:5px;
    text-decoration: none;
    font-weight: 800;
    color: white;
  }
  a.info{
    background: #282828;
    padding: 8px 15px;
    border-radius:5px;
    text-decoration: none;
    font-weight: 600;
    color: white;
    margin-right: 10px;
  }
}
.userInfo{
    margin-top: 0px;
    font-size: 13px;
    a{
      text-decoration: none;
      color: black;
      font-weight: 600;
      &:hover{
        text-decoration: underline;
      }
    }
}
.active {
    font-weight: 700;
}
.out{
  opacity: 1;
  position: relative;
  &::after{
    content:'Мероприятие окончено';
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top:0px;
    right:0px;
    bottom: 0px;
    justify-content: center;
    align-items: center;
    background: #000000d9;
    border-radius: 8px;
    font-size: 15px;
    text-transform: uppercase;
    color:white;
    font-weight: 900;
    letter-spacing: 2px;
  }
}
.activeEvent{
  box-shadow: 0px 0px 50px #9e79ec;
}


</style>
